<template>
  <div>
    <!-- Switch Panel Section -->
    <div class="switch-panel-container">
      <v-tooltip bottom content-class="tooltip-dark">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">Partner</span>
        </template>
        <span class="tooltip-text">Switch to Partner Panel</span>
      </v-tooltip>

      <v-switch
        v-model="isPanelActive"
        @change="switchToPartnerPanel"
        color="white"
        hide-details
      ></v-switch>
    </div>

    
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PANEL_SWITCHER_ACTIONS } from "@/store/action-types";

export default {
  name: "PanelSwitcherView",
  data() {
    return {
      isPanelActive: false,
    };
  },
  computed: {
    ...mapState("panelSwitcher", ["isLoading", "error"]),
  },
  methods: {
    ...mapActions("panelSwitcher", {
      switchToPartner: PANEL_SWITCHER_ACTIONS.SWITCH_TO_PARTNER,
    }),
    switchToPartnerPanel() {
      this.switchToPartner();
    },
  },
};
</script>

<style>
.switch-panel-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  margin-right: 40px;
}

</style>
